import { commaMaskedInputHelper } from "./commaMaskedInputHelper";

/**
 * @description remove all comma from input and cast it to number
 * @example
 * unmaskStrToNum("123,456")  => 123456
 */
export const unmaskStrToNum = (str: string): number => Number(commaMaskedInputHelper.unMask(str));
